import React, { useEffect, useState } from 'react'

import Style from "./Records.module.css"
import { Link, useNavigate } from 'react-router-dom';
import SlideUpWrapper from '../Transitions/SlideUpWrapper';
import { ObjectNotEmpty, setDate } from '../../Utils/helper';
import Icon from 'react-icons-kit';
import { androidOpen } from 'react-icons-kit/ionicons/androidOpen'


export default function Records({ data, Loading }) {
  const navigate = useNavigate();
  // console.log(data)
  // const navigate = useNavigate()

  // const [formData, setformData] = useState('');

  // const updatePopup = (bool) => {
  //   setPopup(bool);
  // };

  // const FormData = () => {
  //   return (
  //     <>
  //       <div style={{ display: "flex", justifyContent: "left", alignContent: "center", margin: "1rem", flexDirection: "column", overflowY: "scroll" }}>
  //         <table border="1" style={{ borderCollapse: 'collapse', width: '100%', borderRadius: "5px" }}>
  //           <thead>
  //             {formData.data.map((item, itemIndex) =>
  //               <tr key={itemIndex}>
  //                 <th>Authnumber</th>
  //                 {item.form_data.map((field, index) => (
  //                   <th key={index} style={{ textAlign: "center", padding: "10px" }}>{field.doc_field_name}</th>
  //                 ))}
  //               </tr>
  //             )}
  //           </thead>
  //           <tbody>
  //             {formData.data.map((item, itemIndex) => (
  //               <tr key={itemIndex}>
  //                 <td style={{ textAlign: "center", padding: "10px", fontWeight: "500" }}>{item.authnumber}</td>
  //                 {item.form_data.map((field, index) => (
  //                   <td style={{ textAlign: "center", padding: "10px", fontWeight: "500" }} key={index}>{field.consented_data}</td>
  //                 ))}
  //               </tr>
  //             ))}
  //           </tbody>
  //         </table>
  //       </div>

  //     </>
  //   )
  // }

  // function handleViewDetail(item) {
  //   if (isForm) {
  //     navigate(`/dashboard/forms/${item.form_uuid}`)
  //   }
  // }

  return (
    <>
      <SlideUpWrapper direction="slide-left">
        <div className="credentials-table">
          <table style={{border:"1px solid lightgray", borderRadius:"10px"}}>
            <thead>
              <tr className="credentials-header bg-lgray">
                <th className="credentials-th">
                  <div className="credentials-table-text">Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Phone No</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Form Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Status</div>
                </th>
                {/* <th className="credentials-th">
                  <div className="credentials-table-text">Checkin</div>
                </th> */}
                <th className="credentials-th">
                  <div className="credentials-table-text">Created At</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Action</div>
                </th>
              </tr>
            </thead>

            <tbody className='Table-Content' style={data.length <= 6 ? { overflowY: "hidden" } : null}>
              {
                ObjectNotEmpty(data) ?
                  data.map((item, index) => (
                    <tr className="credentials-header1" key={index}>
                      <td className="credentials-th">
                        <div className="credentials-table-text">{item.notification_info_name}</div>
                      </td>
                      <td className="credentials-th">
                        <div className="credentials-table-text">{item.notification_info_phone_number}</div>
                      </td>
                      <td className="credentials-th">
                        <Link to={`../forms/${item.form_uuid}`} state={{ formType: item.form_type }} className='credentials-table-text c-primary'>
                          {item.form_name}
                        </Link>
                      </td>
                      <td className="credentials-th">
                        <div className={`credentials-table-text ${item.status_description=="Completed"?"Complete":"Pending"}`} style={{width:"auto"}}>{item.status_description || 'Completed'}</div>
                      </td>
                      {/* <td className="credentials-th">
                        <div className={`credentials-table-text ${item?.checkin}`}>{item?.checkin || 'Completed'}</div>
                      </td> */}
                      <td className="credentials-th">
                        <div className="credentials-table-text">{setDate(item.created_at)}</div>
                      </td>
                      <td className="credentials-th">
                        {
                          item.shared_data_id &&
                          <div className="credentials-table-text">
                            <Link to={`../forms/requestDetails/${item.shared_data_id}`} state={{ formType: item.form_type }} className='link'>
                              <Icon icon={androidOpen} size={'1rem'} />
                              View
                            </Link>
                          </div>
                        }

                      </td>

                    </tr>
                  ))
                  : Loading ? (
                    [...Array(2)].map((_, index) => (
                      <tr className='credentials-header' key={index}>
                        <td className="credentials-th">
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className="credentials-th">
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className="credentials-th">
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className="credentials-th">
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className="credentials-th">
                          <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
                            <div className="shimmer" style={{ width: '4rem', height: "2rem" }}></div>
                            <div className="shimmer" style={{ width: '4rem', height: "2rem" }}></div>
                          </div>
                        </td>
                      </tr>))
                  ) : <tr className="credentials-tr">
                    <td colSpan="6" className="credentials-td text-center">
                      <div className="Data_List">No Data Found</div>
                    </td>
                  </tr>
              }
            </tbody>
          </table>

        </div >
      </SlideUpWrapper>
    </>
  )
}
